<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rO0THy/image/cover.jpg?1730238036600" alt="This image is the cover for the book You Are Here"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You Are Here
      </h1>
      <p class="bookDescription body article font2">
        <b>The bestselling author of <i>The Last Time I’ll Write About You</i> delivers poetic anthems about growth and change that will embolden and empower you.</b><br/><br/><i>You Are Here</i> is Dawn Lanuza’s newest collection of contemporary poetry that lends itself to the idea of giving ourselves second chances. These self-healing poems and words draw on central themes of self-love, self-discovery, and empowerment. In order to survive the vicissitudes of life, <i>You Are Here</i> boldly reminds readers to always choose themselves, and in times where it seems impossible, to find the courage and strength to start anew.<br/><br/><b>“One of my favorite Filipina authors . . . a collection of modern poetry and prose that are meant to be read slowly and savored. These are little vignettes reflecting on love and loss.” —<i>Princess &amp; Pages</i></b><br/><br/><br/><br/><b>“Takes the reader on a hopeful journey from heartbreak to healing. Lanuza’s straightforward writing includes many clever turns of phrase to delight the reader . . . [Her] poems explore the c</b><b>omplexity of womanhood.” —</b><b><i>Rev. Rebecca Writes</i></b><br/><br/><b>“I feel like</b> <b>this collection could help a lot of people dealing with depression (or mental illness in general) to feel seen and understood</b><b>.” —<i>Bookish Wanderess</i></b><br/><br/>Praise for <i>The Last Time I’ll Write About You</i><br/><br/><b>“Poetry that hits you right in the feels. The magic of Lanuza’s writing flows effortlessly with every piece. Definitely left wanting more.” —Sab the Book Eater</b><br/><br/><b>“As you read her work from start to finish, you’ll smile, cry, and maybe even laugh a little.” —<i>She Sounds Like Her</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dawn Lanuza
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0656dea4